import React from 'react';
import { Route } from 'react-router-dom';
import { SecureRoute } from '@okta/okta-react';

const RouteMapping = ({ routes }) => (routes.map((route) => {

    if (route.isSecureRoute && route.path) {

        if (route.exact) {

            return (
                <SecureRoute
                    key={route.path}
                    exact
                    path={route.path}
                    component={route.component}
                    render={(props) => (
                        <route.component
                            childRoutes={route.childRoute}
                            {...props}
                        />
                    )}
                />
            );

        }
        return (
            <SecureRoute
                key={route.path}
                path={route.path}
                component={route.component}
                render={(props) => (
                    <route.component
                        childRoutes={route.childRoute}
                        {...props}
                    />
                )}
            />
        );

    }
    if (!route.isSecureRoute && route.path) {

        if (route.exact) {

            return (
                <Route
                    key={route.path}
                    path={route.path}
                    exact
                    render={(props) => (
                        <route.component
                            childRoutes={route.childRoute}
                            {...props}
                        />
                    )}
                />
            );

        }
        return (
            <Route
                key={route.path}
                path={route.path}
                render={(props) => (
                    <route.component
                        childRoutes={route.childRoute}
                        {...props}
                    />
                )}
            />
        );

    }
    if (route.accordion && route.childRoute) {

        return <RouteMapping routes={route.childRoute} />;

    }
    return null;

}));

export default RouteMapping;
